import log from 'loglevel';
import sessionMgr from './sessionMgr';
import { siteTierConfig } from '../App/App.config';

// Defined by DHXOxygen.js in public/index.html
const DHXOxygen = window.DHXOxygen || {};

// Setup DHOxygen
if (typeof DHXOxygen.setOptions === 'function') {
  DHXOxygen.setOptions({
    environment: siteTierConfig.oxygenTier,
    viewmode: 'redirect',
    responseType: 'se',
    onOpenIDResponse: async function (params) {
      log.log('ETE O2 - oxygen params', params);
      switch (params['loginNeeded']) {
        case 'false':
          // User is logged into Oxygen, store session data
          const userSession = await DHXOxygen.getUserData();
          userSession.CONSUMER_RESPONSE_DATA.requestId =
            params.requestId || null;
          userSession.CONSUMER_RESPONSE_DATA.authorization = `${params.xaxns}=`;
          window.setOxygenUserData(userSession);
          break;
        case 'true':
        default:
          // User is logged out
          window.setOxygenUserData({});
          break;
      }
    },
  });
}

// Check if user is logged in by calling checkimmediate
// onOpenIDResponse call back is dealt with asynchronously
const oxygenCheckSignin = async ({ sessionSig, setSessionSig }) => {
  // Generate signature for Ete Sesssion
  let signatureInfo = {};

  // Check if previously calculated exists
  // we dont want to generate a new signature on every page load
  // If we have a signature and its less that 15 mins old then use it
  if (
    sessionSig &&
    sessionSig.sig &&
    sessionSig.timestamp &&
    Date.now() - sessionSig.timestamp < 14 * 60 * 1000
  ) {
    log.log('ETE O2 - Using existing signature');
    signatureInfo = sessionSig.sig;
  } else {
    // Make the ETE sesssion setting call
    try {
      log.log('ETE O2 - Getting new signature');
      // Assuming we get the signature and its valid
      signatureInfo = await sessionMgr({ type: 'generateSignature' });
      setSessionSig({ sig: signatureInfo, timestamp: Date.now() });
    } catch (e) {
      log.error('unable to generateSignature, sending as empty obj', e);
    }
  }

  let options = {
    returnUrl: siteTierConfig.oxygenCallbackUrl,
    responseType: 'se',
    stateLess: false,
    ...signatureInfo,
  };
  let response = DHXOxygen.checkImmediate(options);
  return response;
};

export { oxygenCheckSignin };
